<template>
  <div class="devcontainer">
    <div class="contenter flexBox">
      <div class="leftcon flexBox-none">
        <div class="searchdiv">
          <el-input placeholder="请输入文章标题搜索" v-model="search"></el-input>
          <el-button slot="append" icon="el-icon-search" circle @click="searchTitle"></el-button>
        </div>
        <el-menu :default-active="htmlObj.id" class="el-menu-vertical-demo" background-color="#ffffff" text-color="#333" active-text-color="#1cc0c9">
          <template v-for="(item,index) in menudata" >
            <el-submenu v-if="item.parentId=='0'" :index="item.id" :key="index" :title="item.title">
              <template slot="title">
                <!-- <i class="el-icon-location"></i> -->
                <span>{{item.title}}</span>
              </template>
              <template v-for="(o,j) in menudata">
                <el-menu-item v-if="o.parentId===item.id" :key="j" :index="o.id" @click="goUrl(o.id)" :title="o.title"> {{o.title}}</el-menu-item>
              </template>
            </el-submenu>
          </template>
        </el-menu>
      </div>
      <div class="content flexBox-center">
        <!-- {{this.contentText}} -->
        <h1>{{htmlObj.title}}</h1>
        <div v-html="htmlObj.content" class="text">
        </div>
        <div class="clearfloat"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { devGuidelist } from '@/services/api/index'
export default {
  name: 'productList',
  // computed: {
  //   guideId() {
  //     return this.getQueryObject()['id']
  //   }
  // },
  watch: {},
  components: {

  },
  data() {
    return {
      search: '',
      menudata: [],
      htmlObj: {
        id: '',
        title: '',
        content: ''
      }
    }
  },
  mounted() {
    this.getGuide()
  },
  beforeDestroy() {

  },
  methods: {
    /**
     * @param {string} url
     * @returns {Object}
    */
    getQueryObject(url) {
      url = url == null ? window.location.href : url
      const search = url.substring(url.lastIndexOf('?') + 1)
      const obj = {}
      const reg = /([^?&=]+)=([^?&=]*)/g
      search.replace(reg, (rs, $1, $2) => {
        const name = decodeURIComponent($1)
        let val = decodeURIComponent($2)
        val = String(val)
        obj[name] = val
        return rs
      })
      return obj
    },
    goUrl(id) {
      this.$router.push({path: 'develop', query: {id: id}})
      this.htmlObj = {
        ...this.htmlObj,
        ...this.setHtmlContent(this.menudata, this.getQueryObject()['id'])
      }
      // this.getGuide()
    },
    getGuide() {
      devGuidelist().then(res => {
        this.menudata = res && res.data.devGuides ? res.data.devGuides : []
        this.htmlObj = {
          ...this.htmlObj,
          ...this.setHtmlContent(this.menudata, this.getQueryObject()['id'])
        }
      })
    },
    setHtmlContent(menudata, id) {
      let htmlObj = {}
      if (!menudata.length) return htmlObj
      if (!id) {
        for(let item of menudata){
          if (item.parentId != 0) {
            htmlObj = item
            break
          }
        }
      } else {
        for(let item of menudata){
          if (item.id === id) {
            htmlObj = item
            break
          }
        }
      }
      return htmlObj
    },
    showCont(data) {
      this.htmlObj = {
        ...this.htmlObj,
        ...data
      }
    },
    searchTitle() {
      let searchText = this.search
      devGuidelist().then(res => {
        // let searchItem = null
        let filterArr = res.data && res.data.devGuides.filter(item => {
          return item.title.indexOf(searchText) !== -1
        })
        console.log(filterArr)
        let selectedItem = filterArr && filterArr.length > 0 ? filterArr[0] : null
        // 一二级标题需要显示（）
        this.menudata = res.data && res.data.devGuides.filter(item => {
          return filterArr.some(tmp => {
            return tmp.id === item.id || tmp.id === item.parentId || tmp.parentId === item.id
          })
        })
        console.log(this.menudata)
        this.menudata.forEach(item => {
          if (selectedItem && item.parentId !== '0' && (selectedItem.id === item.id || selectedItem.id === item.parentId)) {
            this.navselected = item.id
            console.log(this.navselected)
            console.log(item)
            this.showCont(item.content, item.title)
            return
          }
        })
      })
    }
  }
}

</script>
<style rel="stylesheet/scss" lang="scss">
@import "~styles/index.scss";

.devcontainer {
  padding-top: vw(20);
  width: 100%;
  background-color: #F6F6F6;

  .contenter {
    width: 80%;
    margin: 0 auto;
    text-align: center;

    .el-submenu__title {
      padding-right: vw(30);
      @include text-overflow-hidden;
    }

    .leftcon {
      vertical-align: top;
      padding: vw(10) 0;
      width: vw(240);
      background-color: #ffffff;

      .searchdiv {
        width: vw(240);
        border-bottom: solid 1px #DCDFE6;

        .el-input {
          width: vw(180);

          .el-input__inner {
            border: none;
          }
        }

        .el-button {
          border: none;

          :active {
            color: #F56C6C;
          }
        }

        .el-button:focus,
        .el-button:hover {
          color: #F56C6C;
          /* border-color: #c6e2ff; */
          background-color: #FFF0F5;
        }
      }

      .el-menu-item {
        @include text-overflow-hidden;
      }

      .el-menu-item:focus,
      .el-menu-item:hover {
        background-color: #f8f2f2 !important;
      }

      .el-menu-item.is-active {
        background-color: #f8f2f2 !important;
      }

      .el-submenu__title:hover {
        background-color: #f8f2f2 !important;
      }
    }

    .content {
      $sub-gutter-height: vw(80);
      @include calc(height, 100vh - #{$sub-gutter-height});
      margin-left: vw(20);
      padding: vw(35);
      overflow: auto;
      background-color: #ffffff;

      h1 {
        margin-top: vw(20);
        margin-bottom: vw(50);
        font-size: vw(24);
      }

      .text {
        text-align: left;
        line-height: vw(36);
      }

      .clearfloat {
        clear: both;
        height: 0;
        font-size: 1px;
        line-height: 0px;
      }

      img {
        width: 100%;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/develop.vue